import { useRef } from "react";
import { printer } from "../../asset";
import { CustomButton, PageHeader } from "../../components";
import EscortIDCardContainer from "./EscortIDCardContainer";
import { usePrint } from "../../util/hooks/usePrint";
import { useLocation, useNavigate } from "react-router-dom";
import { Attender } from "../../types/attenderType";

export default function EscortIdCard() {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();
  const navigate = useNavigate();

  const attenderData: Attender | undefined = location.state?.attender;

  const handlePrint = usePrint(cardRef, {
    documentTitle: "Escort_ID_Card",
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <PageHeader showBack />
        <div className="flex gap-3">
          <CustomButton
            text="Print/Download"
            color="bg-success-600"
            icon={printer}
            onClick={handlePrint}
          />
        </div>
      </div>

      <div className="bg-white rounded-lg py-7 flex flex-col items-center">
        <div ref={cardRef} className="print-wrapper">
          {attenderData ? (
            <EscortIDCardContainer attender={attenderData} />
          ) : (
            <p>No data available</p>
          )}
        </div>
      </div>
    </div>
  );
}
